<template>
    <nav
        class="navbar navbar-expand-lg navbar-dark"
        style="background-color: #D8EDFE"
    >
        <a
            class="navbar-brand d-lg-none"
            href="https://people-genetics.com"
            target="_blank"
        >
            <img
                alt="People-Genetics"
                class="d-inline-block align-top"
                height="60"
                src="./../../images/logo-ppg.png"
                width="auto"
            />
            <span class="logo-text-bold">People</span
            ><span class="logo-text-light">Genetics</span>
        </a>

        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarToggle"
            aria-controls="navbarToggle"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon" />
        </button>

        <div
            class="collapse navbar-collapse justify-content-between"
            id="navbarToggle"
        >
            <a
                class="navbar-brand d-none d-lg-block"
                href="https://people-genetics.com"
                target="_blank"
            >
                <img
                    alt="People-Genetics"
                    class="d-inline-block align-top"
                    height="60"
                    src="./../../images/logo-ppg.png"
                    width="auto"
                />
                <span class="logo-text-bold">People</span
                ><span class="logo-text-light">Genetics</span>
            </a>

            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.people-genetics.com/people-genetics/"
                        target="_blank"
                    >
                        <span style="color: #455a64;">{{
                            $t("navbar.who-we-are")
                        }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.people-genetics.com/cat%C3%A1logo-de-pruebas/"
                        target="_blank"
                    >
                        <span style="color: #455a64;">{{
                            $t("navbar.our-tests")
                        }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.people-genetics.com/calidad/"
                        target="_blank"
                    >
                        <span style="color: #455a64;">{{
                            $t("navbar.our-quality")
                        }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.people-genetics.com/contacto-1/"
                        target="_blank"
                    >
                        <span style="color: #455a64;">{{
                            $t("navbar.contact")
                        }}</span>
                    </a>
                </li>
            </ul>

            <locale-switcher :text-color="color" />
        </div>
    </nav>
</template>

<script>
import LocaleSwitcher from "./LocaleSwitcher";

export default {
    data() {
        return {
            color: "#465A64"
        };
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale;
        }
    },
    components: {
        LocaleSwitcher
    }
};
</script>

<style scoped></style>
